import { createSelector } from 'reselect';

export const getUser = state => state.user;
export const getUserLocale = createSelector(getUser, user => {
  if (user && user.locale) {
    return user.locale;
  }
  return localStorage.i18nextLng || navigator.language;
});
